import { useState } from 'react';
import TabSelector from 'modules/common/components/TabSelector';
import LabsProvidersContainer from './LabsProvidersContainer';
import { PageTabs, PageTabsOptions } from './helper';
import { Container, Wrapper } from './style';
import LabsServicesContainer from './LabsServicesContainer';

const LabsProvidersAndServicesContainerSelectorPage = () => {
  const [selectedTabOption, setSelectedTabOption] = useState(PageTabs.Providers);

  return (
    <Container>
      <Wrapper>
        <TabSelector
          onChange={payload => {
            setSelectedTabOption(payload.value);
          }}
          options={PageTabsOptions}
          value={selectedTabOption}
        />
        {selectedTabOption === PageTabs.Providers && <LabsProvidersContainer />}
        {selectedTabOption === PageTabs.Services && <LabsServicesContainer />}
      </Wrapper>
    </Container>
  );
};

LabsProvidersAndServicesContainerSelectorPage.propTypes = {};

LabsProvidersAndServicesContainerSelectorPage.defaultProps = {};

export default LabsProvidersAndServicesContainerSelectorPage;
